import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Grid, Typography, Container, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Pagination from '../components/Pagination';

const InstagramAdmin = () => {
  const [posts, setPosts] = useState([]);
  const [formData, setFormData] = useState({
    image: "",
    caption: "",
    description: "",
    link: "",
  });
  const [editData, setEditData] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Sayfa numarası
  const [totalPages, setTotalPages] = useState(1); // Toplam sayfa
  const navigate = useNavigate();

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || user.email !== 'emreonyurt@gmail.com') {
      alert('Access denied.');
      navigate('/projects'); // Redirect to projects page
    }
  }, []);

  const fetchPosts = async (page = 1) => {
    try {
      const response = await api.get(`/api/instagram?page=${page}`);
      setPosts(response.data.posts);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching posts:", error.message);
    }
  };

  useEffect(() => {
    fetchPosts(currentPage);
  }, [currentPage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/instagram", formData);
      alert("Post added successfully!");
      setFormData({ image: "", caption: "", description: "", link: "" });
      const response = await api.get("/api/instagram");
      setPosts(response.data);
    } catch (error) {
      console.error("Error adding post:", error.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/api/instagram/${id}`);
      alert("Post deleted successfully!");
      setPosts(posts.filter((post) => post.id !== id));
    } catch (error) {
      console.error("Error deleting post:", error.message);
    }
  };

  const handleEdit = (post) => {
    setEditData(post);
    setIsEditModalOpen(true);
  };

  const handleEditSubmit = async () => {
    try {
      await api.put(`/api/instagram/${editData.id}`, editData);
      alert("Post updated successfully!");
      setIsEditModalOpen(false);
      const response = await api.get("/api/instagram");
      setPosts(response.data);
    } catch (error) {
      console.error("Error updating post:", error.message);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <Container maxWidth="md" style={{ marginTop: "30px" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Instagram Admin Panel
      </Typography>

      {/* Add Instagram Post Form */}
      <form onSubmit={handleSubmit} style={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Add New Post</Typography>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Image URL"
              fullWidth
              value={formData.image}
              onChange={(e) => setFormData({ ...formData, image: e.target.value })}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Caption"
              fullWidth
              value={formData.caption}
              onChange={(e) => setFormData({ ...formData, caption: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Description"
              fullWidth
              multiline
              rows={3}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Post Link"
              fullWidth
              value={formData.link}
              onChange={(e) => setFormData({ ...formData, link: e.target.value })}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Add Post
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* Instagram Posts List */}
      <Typography variant="h6" style={{ marginTop: "50px" }}>
        All Instagram Posts
      </Typography>
      <Grid container spacing={2} style={{ marginTop: "20px" }}>
        <Grid item xs={12}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #ccc" }}>Image</th>
                <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #ccc" }}>Caption</th>
                <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #ccc" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(posts) && posts.length > 0 ? (
                posts.map((post) => (
                  <tr key={post.id}>
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>
                      <img src={post.image} alt={post.caption} style={{ maxWidth: "100px", borderRadius: "5px" }} />
                    </td>
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>
                      <strong>{post.caption}</strong>
                      <p style={{ margin: 0 }}>{post.description}</p>
                    </td>
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>
                      <a
                        href={post.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#007bff",
                          textDecoration: "none",
                          fontWeight: "bold",
                        }}
                      >
                        View on Instagram
                      </a>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => handleEdit(post)}
                        style={{ marginLeft: "10px" }}
                      >
                        Edit
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => handleDelete(post.id)}
                        style={{ marginLeft: "10px" }}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
                    No posts available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Grid>
      </Grid>

      {/* Pagination */}
      <Grid container justifyContent="center" style={{ marginTop: "20px" }}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Grid>
      {/* Edit Modal */}
      <Dialog open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
        <DialogTitle>Edit Post</DialogTitle>
        <DialogContent>
          <TextField
            label="Image URL"
            fullWidth
            margin="normal"
            value={editData?.image || ""}
            onChange={(e) => setEditData({ ...editData, image: e.target.value })}
          />
          <TextField
            label="Caption"
            fullWidth
            margin="normal"
            value={editData?.caption || ""}
            onChange={(e) => setEditData({ ...editData, caption: e.target.value })}
          />
          <TextField
            label="Description"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            value={editData?.description || ""}
            onChange={(e) => setEditData({ ...editData, description: e.target.value })}
          />
          <TextField
            label="Post Link"
            fullWidth
            margin="normal"
            value={editData?.link || ""}
            onChange={(e) => setEditData({ ...editData, link: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsEditModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleEditSubmit} variant="contained" color="primary">
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default InstagramAdmin;
